<script>
import { RouterView } from 'vue-router'
import HeaderBar from '@/components/common/HeaderBar.vue'
import LeftNav from '@/components/common/LeftNav.vue'

export default {
  name: 'App',
  components: { RouterView, HeaderBar, LeftNav },
  computed: {
    isLogin() {
      return this.$route.name === 'login'
    },
  },
  watch: {
    // 라우트 변경 시 페이지 타이틀 갱신 (immediate — 직접 URL 접근 / 초기 진입 모두 처리)
    $route: { handler() { this.updatePageTitle() }, immediate: true },
    // 헤더에서 언어를 바꾸면 즉시 탭 타이틀도 갱신
    '$i18n.locale'() { this.updatePageTitle() },
  },
  methods: {
    // 페이지 타이틀 — '{페이지명} · {브랜드명}' 포맷. titleKey 가 없는 라우트는 브랜드명만
    updatePageTitle() {
      const brand = this.$t('header.brand_title')
      const key = this.$route?.meta?.titleKey
      document.title = key ? `${this.$t(key)} · ${brand}` : brand
    },
  },
}
</script>

<template>
  <div class="app-root">
    <!-- 로그인 페이지는 레이아웃 없이 단독 렌더 -->
    <template v-if="isLogin">
      <RouterView />
    </template>

    <!-- 일반 페이지: Header + LeftNav + Content -->
    <template v-else>
      <HeaderBar class="app-header" />
      <div class="app-body">
        <LeftNav />
        <main class="app-content">
          <RouterView />
        </main>
      </div>
    </template>
  </div>
</template>

<style>
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

html, body, #app {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: var(--bg-base);
  color: var(--text-primary);
  font-family: Pretendard, 'Noto Sans KR', sans-serif;
}
</style>

<style scoped>
.app-root {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.app-header {
  flex-shrink: 0;
}

.app-body {
  flex: 1;
  display: flex;
  min-height: 0;
  overflow: hidden;
}

.app-content {
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>
